import Vue from "vue";
import Router from "vue-router";
import config from "../public/data/config.json";
Vue.use(Router);

const base =
  process.env.NODE_ENV === "production"
    ? "/"
    : "/";

export default new Router({
  mode: "history",
  base,

  routes: [
    {
      path: "/",
      name: "incicio",
      meta: { layout: "home" },
      component: require("@/pages/Inicio.vue").default // load sync home
    },
    {
      path: "/ranking/:id",
      name: "ranking",
      meta: { layout: "default" },
      component: () => import("@/pages/Ranking.vue")
    },
    {
      path: "/noticias",
      name: "noticias",
      meta: { layout: "default", isLight:true },
      component: () => import("@/pages/Noticias.vue")
    },
    {
      path: "/noticias/:id",
      name: "noticias",
      meta: { layout: "default", isLight: true },
      component: () => import("@/pages/Noticias.vue"),
      props: true
    },
    {
      path: '/login',
      beforeEnter() {
        // Put the full page url including the protocol http(s) below
        window.location = config.INGRESA_URL
      }
    }
    /*,
    {
      path: "/calendario",
      name: "calendario",
      meta: { layout: "no-sidebar" },
      component: () => import("@/pages/Calendario.vue")
    },
       
    {
      path: "*",
      name: "404*",
      component: require("@/pages/404.vue").default // load sync home
    }*/
  ],
  scrollBehavior() {
    window.scrollTo(0, 0);
  }
});